import React from "react";
import {
  formatDecimal,
  formatLakh,
  formatPercent,
  getAchievementToneClass,
} from "../utils/formatters";

function renderValue(item) {
  if (item.kind === "percent" || item.label?.toLowerCase().includes("coverage"))
    return formatPercent(item.value);

  if (item.kind === "currency") return formatLakh(item.value, false);
  if (item.kind === "decimal") return formatDecimal(item.value);

  return item.value;
}

export default function KpiOverview({ items = [] }) {
  if (!items.length) {
    return <div className="coming-soon">🚧 Coming Soon</div>;
  }

  return (
    <div className="kpi-grid">
        {items.map((item, index) => {
          return (
            <div
              className="kpi-card"
              key={item.id ?? item.label ?? index}
            >
              <div className="kpi-label">{item.label}</div>

              <div
                className={`kpi-value ${
                  item.label === "Coverage %"
                    ? `achievement-text ${getAchievementToneClass(Number(item.value))}`
                    : ""
                }`}
              >
                {renderValue(item)}
              </div>

              {item.subtext && (
                <div className="kpi-subtext">{item.subtext}</div>
              )}
            </div>
          );
        })}
      </div>
  );
}